import { subDays } from 'date-fns';
import typeToReducer from 'type-to-reducer';
import {
  CHANGE_DATE_BY_TYPE,
  FETCH_CASHBACK_LIST,
  SET_CURRENT_PAGE,
  CHANGE_DATE_FILTER_TYPE
} from 'accountCashbackActions.js';

let initialState = {
  isPending: true,
  error: null,
  startDate: subDays(new Date(), 1),
  endDate: new Date(),
  data: [],
  isNextPageAvailable: false,
  currentPage: 0,
  limit: 10,
  dateFilterType: '24h'
};

export default typeToReducer(
  {
    [CHANGE_DATE_BY_TYPE]: (state, { payload: { dateType, date } }) => {
      return {
        ...state,
        currentPage: 0,
        [dateType]: date,
      };
    },
    [CHANGE_DATE_FILTER_TYPE]: (state, { payload: { dateFilterType } }) => {
      return {
        ...state,
        dateFilterType
      } 
    },
    [SET_CURRENT_PAGE]: (state, { payload: { currentPage } }) => {
      return {
        ...state,
        currentPage
      };
    },
    [FETCH_CASHBACK_LIST]: {
      PENDING: (state) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (state, { payload: { data, isNextPageAvailable } }) => {
        return {
          ...state,
          isPending: false,
          data, 
          isNextPageAvailable
        };
      },
    },
  },
  initialState
);
